import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const fmt = (v, d = 0) =>
  Number(v).toLocaleString("en-IN", {
    minimumFractionDigits: d,
    maximumFractionDigits: d,
  });

export const useRates = (intervalMs = 5000) => {
  const [rates, setRates] = useState([]);
  const [updatedAt, setUpdatedAt] = useState(null);
  const [usdinr, setUsdinr] = useState(null);
  const [source, setSource] = useState(null);

  useEffect(() => {
    let mounted = true;
    const fetchRates = async () => {
      try {
        const res = await axios.get(`${API}/rates`);
        if (mounted) {
          setRates(res.data.rates);
          setUpdatedAt(res.data.updated_at);
          setUsdinr(res.data.usdinr);
          setSource(res.data.source);
        }
      } catch (e) {
        console.error("rates fetch failed", e);
      }
    };
    fetchRates();
    const id = setInterval(fetchRates, intervalMs);
    return () => {
      mounted = false;
      clearInterval(id);
    };
  }, [intervalMs]);

  return { rates, updatedAt, usdinr, source };
};
